var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0"},[_c('v-row',{staticClass:"ma-0 pa-0"},[_c('v-col',{attrs:{"cols":"6"}},[_vm._t("column-1")],2),_c('v-col',{attrs:{"cols":"6"}},[_vm._t("column-2")],2)],1),_c('v-row',[_vm._t("catch-all")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }